import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Fields, reduxForm } from 'redux-form';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button, Col, Row, Card, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { scrollToFirstError, generateValidation, TextInput } from 'ecs-react-components/dist/index.es';
import validations from './LoginForm.validations'; // note - using same as main login page
import { messages } from './KioskLoginForm.i18n';
import Header from '../../components/Header/Header';

import * as MsgBarActions from '../../redux/modules/system-shared/message-bar-action-creator';

export const fields = ['username', 'password'];

class KioskLoginForm extends Component {
  onSubmit = (values) => {
    this.props.handleLogin(values);
  };

  onFormChange = () => {
    this.props.dispatch(MsgBarActions.dismissMessage());
  };

  getFormattedTitle() {
    const { formatMessage } = this.props.intl;
    const result = formatMessage(messages.page.title,
      {
        facilityName: this.props.facilityName,
        facilityShortName: this.props.facilityShortName,
      });
    return result;
  }

  renderRequired() {
    return (
      <Form.Control.Feedback type="invalid">
        <FormattedMessage {...messages.required.error} />
      </Form.Control.Feedback>
    );
  }

  renderLabel(field, messageFormatId, formatMessage) {
    return (
      <Form.Label className="mb-2" htmlFor={field.input.name}>
        { formatMessage(messageFormatId) }
      </Form.Label>
    );
  }

  renderTextInput(field, type) {
    return (
      <TextInput
        field={ field }
        type={type}
      />
    );
  }

  renderInputElements(field, type, messageFormId, formatMessage) {
    let userErrorHints = null;
    if (field.meta.invalid && !field.input.value.length) {
      userErrorHints = this.renderRequired(field);
    }

    return (
      <Form.Group className="mb-3">
        {this.renderLabel(field, messageFormId, formatMessage)}
        {this.renderTextInput(field, type)}
        { userErrorHints }
      </Form.Group>
    );
  }

  renderFields = (fieldsMeta) => {
    const { formatMessage } = this.props.intl;
    const {
      username,
      password,
    } = fieldsMeta;

    return (
      <div>
        {this.renderInputElements(
          username,
          'text',
          messages.usernameTitle.label,
          formatMessage)}
        {this.renderInputElements(
          password,
          'password',
          messages.passwordTitle.label,
          formatMessage)}
      </div>
    );
  }

  render() {
    const { handleSubmit } = this.props;
    return (
      <div className="kiosk-login-layout-view">
        <Row className="justify-content-md-center mt-3">
          <Col md={6}>
            <div className="kiosk-header">
              <Header
                headerTitle={this.getFormattedTitle()}
                hasLanguageDropdown
              />
            </div>

            <Card className="p-4 w-100">
              <Card.Body>
                <h5 className="mb-3">
                  <FormattedMessage {...messages.login.label} />
                </h5>

                <form onSubmit={handleSubmit(this.onSubmit)}
                  onChange={this.onFormChange}
                >
                  <Fields names={fields} component={this.renderFields} />

                  <div className="button-area">
                    <Button type="submit" aria-describedby="button_description">
                      <FormattedMessage {...messages.login.label} />
                    </Button>
                  </div>
                </form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

KioskLoginForm.propTypes = {
  handleSubmit: PropTypes.func,
  handleLogin: PropTypes.func.isRequired,
  intl: PropTypes.object,
  errorMessage: PropTypes.string,
  facilityPortalName: PropTypes.string,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  submitFailed: PropTypes.bool,
  dispatch: PropTypes.func,
  facilityName: PropTypes.string,
  facilityShortName: PropTypes.string,
};

const reduxFormConfig = {
  form: 'kioskLoginForm',
  enableReinitialize: true,
  onSubmitFail: (errors) => scrollToFirstError(errors, fields),
  fields,
  ...generateValidation(validations),
};

const mapStateToProps = (state) => ({
  facilityPortalName: state.facility ? state.facility.facilityPortalName : null,
  facilityName: state.facility ? state.facility.facilityName : null,
  facilityShortName: state.facility ? state.facility.facilityShortName : null,
});


export default reduxForm(reduxFormConfig)(connect(mapStateToProps)(injectIntl(KioskLoginForm)));
